import React, { useCallback, useEffect, useState } from 'react';
import './../Form.scss';
import './ProdutosForm.scss';
import { useHistory, useParams } from 'react-router';
import service from '../../../services/produtos';
import serviceCatalogos from '../../../services/catalogos';
import serviceCategorias from '../../../services/categorias';
import { useForm } from "react-hook-form";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBan, faSave } from '@fortawesome/free-solid-svg-icons';
import { hasText } from '../../../utils/utils';
import { actions as actionsSite } from './../../../redux/actions/site';
import { useDispatch } from 'react-redux';
import { formatCurrency } from '../../../utils/Money';

const ProdutosForm = props => {

    const history = useHistory();
    const params = useParams();
    const [loading, setLoading] = useState(true);
    const [produto, setProduto] = useState({});
    const [categorias, setCategorias] = useState([]);
    const [catalogos, setCatalogos] = useState([]);
    const dispatch = useDispatch();

    const { register, handleSubmit, setValue } = useForm();

    const onSubmit = data => {
        save(data);
    };

    const carregarProduto = useCallback(async (id) => {
        setLoading(true);
        const produtoInicial = await service.getById(id);
        setProduto(produtoInicial);
        setLoading(false);
    }, []);


    useEffect(() => {
        const run = async () => {
            const _catalogos = serviceCatalogos.get(`?catalogo=NULL&sort=nome&active=true`);
            const _categorias = serviceCategorias.get(`?sort=nome&active=true`);
            const [_resCatalogos, _resCategorias] = await Promise.all([_catalogos, _categorias]);
            setCategorias(_resCategorias.rows);
            setCatalogos(_resCatalogos.rows);
            if (params.id) {
                carregarProduto(params.id);
            } else {
                setLoading(false);
            }
        }
        run();

    }, [carregarProduto, params.id]);

    const save = async (data) => {
        dispatch(actionsSite.setLoadingMsg("Enviando dados..."));
        const res = await service.upsert(data, produto._id);


        dispatch(actionsSite.setLoadingMsg(res.msg));

        setTimeout(() => {
            dispatch(actionsSite.setLoadingMsg(""));
            if (!params.id && !res.erro) {
                history.push('/painel/produtos');
            }
        }, 3000);

    }

    const changeCatalogo = e => {
        const _produto = { ...produto };
        _produto.catalogo = e.target.value;
        setProduto(_produto);
    }

    const optionCatalogos = () => {
        const op = [...catalogos];
        op.unshift({ _id: "", nome: "Selecione um catálogo" });
        return op.map((o, i) => {
            return <option key={i} value={o._id}>{o.nome}</option>;
        });
    }

    const changeCategoria = e => {
        const _produto = { ...produto };
        _produto.categoria = e.target.value;
        setProduto(_produto);
    }

    const optionCategorias = () => {
        const op = [...categorias];
        op.unshift({ _id: "", nome: "Selecione uma categoria" });
        return op.map((o, i) => {
            return <option key={i} value={o._id}>{o.nome}</option>;
        });
    }

    const changeValueMoney = (e, campo) => {
        const value = e.target.value;
        const newValue = formatCurrency(value);
        setValue(campo, newValue);
        document.querySelector("#" + campo).classList.add('hasText');
    }

    const changeValueFloat = (e, campo) => {
        const value = e.target.value;
        const newValue = formatCurrency(value, false);
        setValue(campo, newValue);
        document.querySelector("#" + campo).classList.add('hasText');
    }

    return (
        <>
            {!loading &&
                <form onSubmit={handleSubmit(onSubmit)} className="formModule branco produtosForm">
                    <div className="acoes">
                        <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                        <button type="button" className="cancelar" onClick={() => history.push('/painel/produtos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                    </div>
                    <div className="break"></div>
                    <div className="field">
                        <input className={produto.codigo ? 'hasText' : ''} name="codigo" id="codigo" defaultValue={produto.codigo} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="codigo">Código</label>
                    </div>

                    <div className="field">
                        <input className={produto.nome ? 'hasText' : ''} name="nome" id="nome" defaultValue={produto.nome} onKeyUp={(e) => hasText(e)} type="text" ref={register({ required: true })} />
                        <label htmlFor="nome">Nome</label>
                    </div>
                    <div className="break"></div>
                    <div className="field">
                        <select name="catalogo" className="hasText" ref={register()} id="catalogo" value={produto.catalogo || ""} onChange={(e) => changeCatalogo(e)}>
                            {optionCatalogos()}
                        </select>
                        <label htmlFor="catalogo">Catálogo</label>
                    </div>
                    <div className="field">
                        <select name="categoria" className="hasText" ref={register()} id="categoria" value={produto.categoria || ""} onChange={(e) => changeCategoria(e)}>
                            {optionCategorias()}
                        </select>
                        <label htmlFor="categoria">Categoria</label>
                    </div>
                    <div className="break"></div>
                    <div className="field">
                        <input className={produto.pagina ? 'hasText' : ''} name="pagina" id="pagina" defaultValue={produto.pagina} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} />
                        <label htmlFor="pagina">Página</label>
                    </div>
                    <div className="field">
                        <input className={produto.tamanho ? 'hasText' : ''} name="tamanho" id="tamanho" defaultValue={produto.tamanho} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} />
                        <label htmlFor="tamanho">Tamanho</label>
                    </div>

                    <div className="break"></div>
                    <div className="field">
                        {/* <input className={produto.valor ? 'hasText' : ''} name="valor" id="valor" defaultValue={produto.valor} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} /> */}
                        <input className={produto.valor ? 'hasText' : ''} name="valor" id="valor"
                                onKeyUp={(e) => { hasText(e) }}
                                onChange={(e) => { changeValueMoney(e, 'valor') }}
                                ref={register({ required: true })}
                                defaultValue={formatCurrency(produto.valor)} type="text" />
                        <label htmlFor="valor">Valor</label>
                    </div>
                    <div className="field">
                        <input className={produto.pontos ? 'hasText' : ''} name="pontos" id="pontos" 
                            onChange={(e) => { changeValueFloat(e, 'pontos') }}
                            defaultValue={formatCurrency(produto.pontos,false)} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} />
                        <label htmlFor="pontos">Pontos</label>
                    </div>

                    <div className="break"></div>
                    <div className="field">
                        <input className={produto.estoqueMin ? 'hasText' : ''} name="estoqueMin" id="estoqueMin" defaultValue={produto.estoqueMin} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} />
                        <label htmlFor="estoqueMin">Estoque mínimo</label>
                    </div>
                    <div className="field">
                        <input className={produto.estoque ? 'hasText' : ''} name="estoque" id="estoque" defaultValue={produto.estoque} onKeyUp={(e) => hasText(e)}
                            type="text" ref={register()} />
                        <label htmlFor="estoque">Estoque</label>
                    </div>

                    <div className="break"></div>
                    <div className="acoes">
                        <button type="submit" className="salvar"><FontAwesomeIcon icon={faSave} /> {params.id ? 'Editar' : 'Salvar'}</button>
                        <button type="button" className="cancelar" onClick={() => history.push('/painel/produtos')}><FontAwesomeIcon icon={faBan} /> Cancelar</button>
                    </div>
                </form>}
            {loading && "Carregando..."}
        </>
    )
}

export default ProdutosForm;